import { render } from "./VisitDashboard.vue?vue&type=template&id=195415ae&scoped=true"
import script from "./VisitDashboard.vue?vue&type=script&lang=js"
export * from "./VisitDashboard.vue?vue&type=script&lang=js"

import "./VisitDashboard.vue?vue&type=style&index=0&id=195415ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-195415ae"]])

export default __exports__